import { Modal } from "bootstrap";
import CompliantConsentManager from "./consent.js";

document.addEventListener("DOMContentLoaded", function () {
    const consentBanner = document.getElementById("tessellate-consent-banner");

    // FIX: All button wiring is now inside the gtag + banner guard.
    // Previously, the button event listeners were attached in a second
    // `if (consentBanner)` block outside the gtag check, meaning consentManager
    // could be undefined if gtag hadn't loaded yet (e.g. on slow connections
    // or when an ad blocker delays the GTM snippet), causing JS errors on click.
    if (typeof window.gtag === "function" && consentBanner) {
        const consentManager = new CompliantConsentManager();

        const cookieConsent = consentManager.getConsentFromCookie();

        // Show banner only if the user hasn't made a choice yet
        if (!cookieConsent) {
            consentBanner.style.display = "block";
        }

        // --- Grant all ---
        document.querySelectorAll(".consent-btn--grant").forEach((button) => {
            button.addEventListener("click", () => consentManager.grantConsent());
        });

        // --- Revoke all ---
        const revokeBtn = document.getElementById("revoke-btn");
        if (revokeBtn) {
            revokeBtn.addEventListener("click", () => consentManager.revokeConsent());
        }

        // --- Confirm granular choices from modal ---
        const confirmBtn = document.getElementById("confirm-btn");
        if (confirmBtn) {
            confirmBtn.addEventListener("click", () => {
                const consentModal = document.getElementById("consentModal");
                const checkboxes = consentModal.querySelectorAll("input[type='checkbox']");
                const obj = {};

                checkboxes.forEach((checkbox) => {
                    obj[checkbox.id] = checkbox.checked ? "granted" : "denied";
                });

                // ad_user_data and ad_personalization mirror ad_storage
                if (obj["ad_storage"] === "denied") {
                    obj["ad_user_data"] = "denied";
                    obj["ad_personalization"] = "denied";
                }

                if (obj["ad_storage"] === "granted") {
                    obj["ad_user_data"] = "granted";
                    obj["ad_personalization"] = "granted";
                }

                consentManager.updateConsent(obj);

                consentBanner.style.display = "none";
            });
        }

        // --- Accept all from modal ---
        document.querySelectorAll(".consent-btn--update-all").forEach((button) => {
            button.addEventListener("click", () => {
                const obj = {
                    ad_storage: "granted",
                    ad_user_data: "granted",
                    ad_personalization: "granted",
                    analytics_storage: "granted",
                };

                if (site_data.meta === "yes") {
                    obj["meta"] = "granted";
                }

                consentManager.updateConsent(obj);

                consentBanner.style.display = "none";
            });
        });
    }
});